<h1 mat-dialog-title>Editar Processo</h1>

<div mat-dialog-content>
  <form [formGroup]="editForm" class="form-container">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Informações do Processo</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <mat-form-field appearance="fill">
          <mat-label>Número do Processo</mat-label>
          <input matInput formControlName="processNumber" readonly />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Tipo do Processo</mat-label>
          <input matInput formControlName="processType" readonly />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Prazo (em dias)</mat-label>
          <input matInput formControlName="dueDays" type="number" readonly />
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title>Informações Gerais</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <mat-form-field appearance="fill">
          <mat-label>Empresa</mat-label>
          <input matInput formControlName="empresa" />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Descrição</mat-label>
          <textarea matInput formControlName="descricao"></textarea>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Tema</mat-label>
          <input matInput formControlName="theme" />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Fase</mat-label>
          <input matInput formControlName="fase" />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Data de Inclusão</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="registerDate" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Situação</mat-label>
          <mat-select formControlName="status">
            <mat-option *ngFor="let status of processStatusList" [value]="status">
              {{ status }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Cadastro do Imóvel</mat-label>
          <input matInput formControlName="propertyRegister" />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Grupo</mat-label>
          <input matInput formControlName="group" />
        </mat-form-field>
      </mat-card-content>
    </mat-card>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-button color="primary" (click)="onSave()" [disabled]="editForm.invalid">
    Salvar
  </button>
</div>